export default __webpack_public_path__ + "static/media/Fanzone-Hexagon-Logo-Footer.7bb1d26d.png";